import axios from "axios";
import AppSettings from "../appsettings";

const API_BASE_URL = AppSettings.API_BASE_URL;

// -------------------- Auth API Calls --------------------

export const loginUser = async (email, password) => {
  const response = await axios.post(`${API_BASE_URL}/auth/login`, {
    email,
    password,
  });

  return response.data; // { accessToken, refreshToken }
};

export const refreshAccessToken = async () => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) throw new Error("No refresh token available");

  const response = await axios.post(`${API_BASE_URL}/auth/refresh`, {
    refreshToken,
  });

  const { accessToken } = response.data;
  setAuthToken(accessToken);
  return accessToken;
};

// -------------------- Token Helpers --------------------

export const setAuthToken = (token) => {
  localStorage.setItem("accessToken", token);
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

export const getAuthToken = () => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }
  return token;
};

export const clearAuthToken = () => {
  localStorage.removeItem("accessToken");
  delete axios.defaults.headers.common["Authorization"];
};

export const setRefreshToken = (token) => {
  localStorage.setItem("refreshToken", token);
};

export const getRefreshToken = () => {
  return localStorage.getItem("refreshToken");
};

export const clearRefreshToken = () => {
  localStorage.removeItem("refreshToken");
};
